module.exports = __webpack_public_path__ + "img/enterprise.00b3575d.png";